// ----------------------------------------------------------------------------
// Nombre del Programa : SolicitudComunicado
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza para la vista y funciones de el listado de solicitudes de comunicado
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import './SolicitudComunicados.scss';
import { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Paginador } from '../../components/paginador/Paginador';
import { SolicitudComunicadosProps } from '../../interfaces/solicitudComunicadosInterfaces';
import { getSolicitudes } from '../../Services/SolicitudComunicadosService';

export const SolicitudComunicados = () => {
  const PAGE_SIZE = 8;
  const [pagActual, setPagActual] = useState<number>(0);
  const [solicitudes, setSolicitudes] = useState<SolicitudComunicadosProps[]>(
    []
  );
  const [cargado, setCargado] = useState<boolean>(false);

  useEffect(() => {
    getSolicitudes().then((response) => {
      if (response.data && response.data.data) {
        console.log(response.data.data);
        setSolicitudes(response.data.data);
        setCargado(true);
      }
    });
  }, []);

  const solicitudesMostrar = () =>
    solicitudes.filter(
      (_, i) =>
        i >= PAGE_SIZE * pagActual && i <= PAGE_SIZE * pagActual + PAGE_SIZE - 1
    );

  const cambiarPagina = (pag) => {
    setPagActual(pag);
  };

  return (
    <>
      <div className="m-5">
        <Row className="mb-3">
          <Col className="heading-1">Solicitudes</Col>
        </Row>
        <Table responsive>
          <thead className="colorgray2">
            <tr>
              <th>Necesidad</th>
              <th>Nombre solicito</th>
              <th>Area solicito</th>
              <th>Tipo de mensaje</th>
              <th>Segmento</th>
              <th>Fecha de solicitud</th>
              <th>Fecha de publicación</th>
              <th>Estatus</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {solicitudes.length > 0 ? (
              solicitudesMostrar().map((solicitud, index) => (
                <tr
                  key={solicitud.solicitudcomunicado_id}
                  className="colorgray2"
                >
                  <td
                    className={
                      index === 0
                        ? ''
                        : index === solicitudes.length - 1
                          ? ''
                          : ''
                    }
                  >
                    {solicitud!.tiponecesidad_id!.nombre}
                  </td>
                  <td>{solicitud.nombreSolicito}</td>
                  <td>
                    {solicitud.areaSolicito ? solicitud.areaSolicito : ''}
                  </td>
                  <td>
                    {solicitud.tipomensaje_id
                      ? solicitud!.tipomensaje_id!.nombre
                      : ''}
                  </td>
                  <td>{solicitud.segmento ? 'Especifico' : 'General'}</td>
                  <td>{moment(solicitud.fecInserta).format('DD/MM/YYYY')}</td>
                  <td>
                    {solicitud.fechaPublicacion
                      ? moment(solicitud.fechaPublicacion).format('DD/MM/YYYY')
                      : ''}
                  </td>
                  <td
                    className={
                      solicitud!.solicitudestatus_id!.solicitudestatus_id === 1
                        ? 'textoazul'
                        : solicitud!.solicitudestatus_id!
                          .solicitudestatus_id === 2
                          ? 'textoverde'
                          : solicitud!.solicitudestatus_id!
                            .solicitudestatus_id === 3
                            ? 'textoverde2'
                            : 'textorojo'
                    }
                  >
                    {solicitud!.solicitudestatus_id!.nombre}
                  </td>
                  <td
                    className={
                      index === 0
                        ? ''
                        : index === solicitudes.length - 1
                          ? ''
                          : ''
                    }
                    width="140"
                  >
                    <Link
                      to={
                        '/solicitud-comunicados/detalle-solicitud/' +
                        solicitud.solicitudcomunicado_id
                      }
                    >
                      <Button variant="secondary" className="btntable me-2">
                        <div className="material-icons">visibility</div>
                      </Button>
                    </Link>
                  </td>
                </tr>
              ))
            ) : cargado ? (
              <tr className="colorgray2">
                <td className="nodatos    " colSpan={9}>
                  No Existen Datos
                </td>
              </tr>
            ) : (
              <tr></tr>
            )}
          </tbody>
        </Table>
        <Row>
          <Paginador
            tamanoPagina={PAGE_SIZE}
            totalRegistros={solicitudes.length}
            paginaCambiada={cambiarPagina}
          ></Paginador>
        </Row>
      </div>
    </>
  );
};
